import styled from '@emotion/styled'
import React from 'react'

import { APP_TYPE } from '@/types/User'

import { AppSelection } from './AppSelection'
import { MenuItems } from './MenuItems'
import { Notifications } from './Notifications'
import { UserNavigation } from './UserNavigation'

type Props = {
  activeApp: APP_TYPE
  isUnreadNotifications: boolean
  minimize: boolean
  numberOfUnreadNotifications: number
  onNavLinkPress: (path: string) => void
}

export const MobileSidebarNavigation = ({
  isUnreadNotifications,
  onNavLinkPress,
  minimize,
  numberOfUnreadNotifications,
  activeApp,
}: Props) => {
  return (
    <MobileNavigationStyled activeApp={activeApp} minimize={minimize}>
      <ul className="grid">
        <AppSelection activeApp={activeApp} minimize={minimize} smallScreen={true} />
        <MenuItems activeApp={activeApp} onNavLinkPress={onNavLinkPress} />

        <Notifications
          isUnreadNotifications={isUnreadNotifications}
          numberOfUnreadNotifications={numberOfUnreadNotifications}
          onNavLinkPress={onNavLinkPress}
        />
        <UserNavigation activeApp={activeApp} minimize={minimize} smallScreen={true} />
      </ul>
    </MobileNavigationStyled>
  )
}

const MobileNavigationStyled = styled.div<{ activeApp: APP_TYPE; minimize: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 50;
  top: 4rem;
  padding-top: 0.75rem;
  ${({ activeApp }) => (activeApp === APP_TYPE.SALES ? 'background-color: white;' : 'background-color: #000000;')}
  opacity: 0;
  visibility: hidden;
  height: calc((var(--vh) * 100) - 4rem);
  transition:
    opacity 0.3s,
    visibility 0.3s,
    height 0.25s;
  overflow: hidden;

  ${({ minimize }) => !minimize && 'opacity: 1; visibility: visible;'}

  ul {
    button {
      position: relative;
      padding-left: 1rem;
      padding-right: 1rem;

      &.active-selection {
        ${({ activeApp }) =>
          activeApp === APP_TYPE.SALES ? 'background-color: #E7E6E4;' : 'background-color: #2E2B29;'}
      }
      &.active-selection::before {
        position: absolute;
        width: 0.25rem;
        height: 100%;
        content: '';
        left: 0;
        background-color: #09a090;
      }

      div {
        display: flex;
        width: 100%;
        padding-left: 1rem;
        padding-right: 1rem;
        position: relative;
        align-items: center;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        font-size: 1rem;
        line-height: 1;
        ${({ activeApp }) => (activeApp === APP_TYPE.SALES ? 'color: #000000;' : 'color: white;')}
      }

      li {
        display: flex;
        align-items: center;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        font-size: 1rem;
        font-weight: 300;
        line-height: 1;
        width: 100%;
        position: relative;
        ${({ activeApp }) => (activeApp === APP_TYPE.SALES ? 'color: #000000;' : 'color: white;')}
      }

      svg {
        width: 1.5rem;
        ${({ minimize }) => !minimize && 'margin-right: 1rem;'}
      }

      span {
        ${({ minimize }) => (minimize ? 'display: none; opacity: 0;' : 'display: block; opacity: 1;')}

        ${({ activeApp }) => {
          if (activeApp !== APP_TYPE.SALES) {
            return 'font-weight: 700;'
          }
        }}
      }
    }
  }
`
